/* globals angular */
import '../app.less';

window.v11nApp = angular.module('v11nApp', [
    'MW.Framework.Breadcrumb',
    'MW.Dashboard.DashboardWidgetService',
    'MW.DashboardLegacy.Constants',
    'MW.Framework.InformationTypeService',
    'MW.InsDashboard.InsWidgetConfigService',
    'MW.v11n.MapService',
    'MW.Framework.TextFilters',
    'MW.Dashboard.CommentService',
    'MW.Dashboard.ExportService',
    'MW.Framework.DataExportService',
    'MW.Framework.AppBarTitleService'
]);
